import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66ff5690"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Ranking")
const _hoisted_2 = { class: "user-info-section" }
const _hoisted_3 = { class: "user-profile" }
const _hoisted_4 = { class: "profile-img" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "user-details" }
const _hoisted_7 = { class: "stats-cards" }
const _hoisted_8 = { class: "details-box ranking shadow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "O", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-ellipsis" }, "Totale Coins", -1))
const _hoisted_11 = { class: "text-ellipsis" }
const _hoisted_12 = { class: "details-box earned shadow" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Match Eseguiti", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Utenti")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Classe")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Classi")
const _hoisted_18 = { class: "profile-img winner-img" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "winner-position" }
const _hoisted_22 = { class: "winner-name" }
const _hoisted_23 = { class: "winner-points" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { "item-start": "" }
const _hoisted_26 = { class: "profile-img list-avatar" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { "item-end": "" }
const _hoisted_31 = { "item-start": "" }
const _hoisted_32 = { class: "profile-img list-avatar" }
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { "item-end": "" }
const _hoisted_37 = { "item-start": "" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { "item-end": "" }

import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonAvatar,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonCol,
  IonRow,
  IonBadge,
  IonList,
  IonItem,
} from '@ionic/vue';
import {ref, computed} from "vue";
import RankingService from "@/api/ranking/RankingService";
import MatchesService from "@/api/matches/MatchesService";
import HidingRankingMessage from "@/views/ranking/hidingRankingMessage.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentUser = ref<any>(JSON.parse(localStorage.getItem('userData') || '{}'))
const currentClass = JSON.parse(localStorage.getItem('currentClass') || '{}')
const activeTab = ref('rankingLastMatchByUser')

const {
  fetchRanking,
  getRanking,
} = RankingService()
fetchRanking()

const ranking = computed(() => getRanking())

const {
  fetchMatches,
  userTotalcoins,
  userTotalmatches,
} = MatchesService()
fetchMatches()

const resolveWinner = (index: number) => {
  if (index === 0) return {class: 'first_winner', text: 1}
  if (index === 1) return {class: 'second_winner', text: 2}
  if (index === 2) return {class: 'third_winner', text: 3}
}

function findClassInRanking() {
  const r = ranking.value
  if (r && r.rankingLastMatchByClass && r.rankingLastMatchByClass.length) {
    const found = r.rankingLastMatchByClass.find((classe: any) => classe.id === currentClass.id)
    return found ? found.users : []
  }
  return []
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton), { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "bg-light" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(IonAvatar), { class: "fit-avatar" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: currentUser.value && currentUser.value.avatar ? currentUser.value.avatar : 'https://raw.githubusercontent.com/ionic-team/ionic-docs/a3574bedc5cf5d68fe3df755adc228dc7e01726a/src/demos/api/avatar/avatar.svg',
                      alt: currentUser.value.fullName
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(IonBadge), {
                  style: _normalizeStyle([{"white-space":"normal","text-align":"left"}, `background: ${currentUser.value.color || 'transparent; color: black; padding-left: 0; border-radius: 0'}`])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(currentUser.value.fullName), 1)
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createElementVNode("small", null, _toDisplayString(currentUser.value.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref(userTotalcoins)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h2", null, [
                  _createElementVNode("img", {
                    src: require('@/assets/imgs/white_icon.png')
                  }, null, 8, _hoisted_13)
                ]),
                _hoisted_14,
                _createElementVNode("h3", null, _toDisplayString(_unref(userTotalmatches)), 1)
              ])
            ])
          ]),
          _createVNode(_unref(IonSegment), {
            value: activeTab.value,
            onIonChange: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event.detail.value))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSegmentButton), { value: "rankingLastMatchByUser" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "rankingLastMatchByClass" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "rankingLastMatchByClassPoints" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (_unref(ranking) && !_unref(ranking).hide_ranking && activeTab.value === 'rankingLastMatchByUser' && _unref(ranking).rankingLastMatchByUser && _unref(ranking).rankingLastMatchByUser.length >= 3)
            ? (_openBlock(), _createBlock(_unref(IonRow), {
                key: 0,
                class: "winners-row"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,0,2], (index) => {
                    return _createVNode(_unref(IonCol), {
                      key: index,
                      size: "4",
                      class: _normalizeClass(["col ion-text-center", resolveWinner(index).class])
                    }, {
                      default: _withCtx(() => [
                        (_unref(ranking).rankingLastMatchByUser[index])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_unref(IonAvatar), { class: "fit-avatar" }, {
                                  default: _withCtx(() => [
                                    (_unref(ranking).rankingLastMatchByUser[index].avatar)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(ranking).preLinkAvatar+_unref(ranking).rankingLastMatchByUser[index].avatar,
                                          alt: _unref(ranking).rankingLastMatchByUser[index].email
                                        }, null, 8, _hoisted_19))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: require('@/assets/avatar/avatar.svg'),
                                          alt: _unref(ranking).rankingLastMatchByUser[index].email
                                        }, null, 8, _hoisted_20))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("h2", _hoisted_21, _toDisplayString(resolveWinner(index).text), 1),
                              _createElementVNode("h3", _hoisted_22, [
                                _createVNode(_unref(IonBadge), {
                                  style: _normalizeStyle([{"white-space":"normal","text-align":"center"}, `background: ${_unref(ranking).rankingLastMatchByUser[index].color || 'transparent; color: black; padding-left: 0; border-radius: 0'}`])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(ranking).rankingLastMatchByUser[index].first_name) + " " + _toDisplayString(_unref(ranking).rankingLastMatchByUser[index].last_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["style"]),
                                _createElementVNode("small", null, _toDisplayString(_unref(ranking).rankingLastMatchByUser[index].email), 1)
                              ]),
                              _createElementVNode("p", _hoisted_23, [
                                _createElementVNode("img", {
                                  src: require('@/assets/imgs/co_icon_orange.png')
                                }, null, 8, _hoisted_24),
                                _createTextVNode(" " + _toDisplayString(_unref(ranking).rankingLastMatchByUser[index].pivot.points ? _unref(ranking).rankingLastMatchByUser[index].pivot.points : 0), 1)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  }), 64))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (activeTab.value === 'rankingLastMatchByUser')
            ? (_openBlock(), _createBlock(_unref(IonList), {
                key: 1,
                lines: "none",
                class: "ranking-list"
              }, {
                default: _withCtx(() => [
                  (_unref(ranking) && _unref(ranking).hide_ranking)
                    ? (_openBlock(), _createBlock(HidingRankingMessage, {
                        key: 0,
                        class: "ion-padding",
                        ranking: _unref(ranking)
                      }, null, 8, ["ranking"]))
                    : (_unref(ranking) && _unref(ranking).rankingLastMatchByUser)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(ranking).rankingLastMatchByUser, (user, index) => {
                          return (_openBlock(), _createBlock(_unref(IonItem), {
                            key: user.id,
                            class: "ranking-item"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_unref(IonAvatar), { class: "fit-avatar" }, {
                                    default: _withCtx(() => [
                                      (user.avatar)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: _unref(ranking).preLinkAvatar+user.avatar
                                          }, null, 8, _hoisted_27))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: require('@/assets/avatar/avatar.svg')
                                          }, null, 8, _hoisted_28))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h2", null, [
                                    _createVNode(_unref(IonBadge), {
                                      style: _normalizeStyle([{"white-space":"normal","text-align":"left"}, `background: ${user.color || 'transparent; color: black; padding-left: 0; border-radius: 0'}`])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["style"])
                                  ]),
                                  _createElementVNode("small", null, _toDisplayString(user.email), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("p", null, [
                                _createElementVNode("img", {
                                  src: require('@/assets/imgs/co_icon_orange.png')
                                }, null, 8, _hoisted_29),
                                _createTextVNode(" " + _toDisplayString(user.pivot.points ? user.pivot.points : 0), 1)
                              ]),
                              _createElementVNode("h5", _hoisted_30, "#" + _toDisplayString(index + 1), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : (activeTab.value === 'rankingLastMatchByClass')
              ? (_openBlock(), _createBlock(_unref(IonList), {
                  key: 2,
                  lines: "none",
                  class: "ranking-list"
                }, {
                  default: _withCtx(() => [
                    (_unref(ranking) && _unref(ranking).hide_ranking)
                      ? (_openBlock(), _createBlock(HidingRankingMessage, {
                          key: 0,
                          class: "ion-padding",
                          ranking: _unref(ranking)
                        }, null, 8, ["ranking"]))
                      : (_unref(ranking) && _unref(ranking).rankingLastMatchByClass)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(findClassInRanking(), (user, index) => {
                            return (_openBlock(), _createBlock(_unref(IonItem), {
                              key: user.id,
                              class: "ranking-item"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_unref(IonAvatar), { class: "fit-avatar" }, {
                                      default: _withCtx(() => [
                                        (user.avatar)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: _unref(ranking).preLinkAvatar+user.avatar
                                            }, null, 8, _hoisted_33))
                                          : (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: require('@/assets/avatar/avatar.svg')
                                            }, null, 8, _hoisted_34))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("h2", null, [
                                    _createTextVNode(_toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1),
                                    _createElementVNode("small", null, _toDisplayString(user.email), 1)
                                  ])
                                ]),
                                _createElementVNode("p", null, [
                                  _createElementVNode("img", {
                                    src: require('@/assets/imgs/co_icon_orange.png')
                                  }, null, 8, _hoisted_35),
                                  _createTextVNode(" " + _toDisplayString(user.matches[0] && user.matches[0].pivot.points ? user.matches[0].pivot.points : 0), 1)
                                ]),
                                _createElementVNode("h5", _hoisted_36, "#" + _toDisplayString(index + 1), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (activeTab.value === 'rankingLastMatchByClassPoints')
                ? (_openBlock(), _createBlock(_unref(IonList), {
                    key: 3,
                    lines: "none",
                    class: "ranking-list"
                  }, {
                    default: _withCtx(() => [
                      (_unref(ranking) && _unref(ranking).hide_ranking)
                        ? (_openBlock(), _createBlock(HidingRankingMessage, {
                            key: 0,
                            class: "ion-padding",
                            ranking: _unref(ranking)
                          }, null, 8, ["ranking"]))
                        : (_unref(ranking) && _unref(ranking).rankingLastMatchByClassPoints)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(ranking).rankingLastMatchByClassPoints, (classe, index) => {
                              return (_openBlock(), _createBlock(_unref(IonItem), {
                                key: classe.id,
                                class: "ranking-item"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("h2", null, _toDisplayString(classe.name), 1)
                                  ]),
                                  _createElementVNode("p", null, [
                                    _createElementVNode("img", {
                                      src: require('@/assets/imgs/co_icon_orange.png')
                                    }, null, 8, _hoisted_38),
                                    _createTextVNode(" " + _toDisplayString(classe.points ? classe.points : 0), 1)
                                  ]),
                                  _createElementVNode("h5", _hoisted_39, "#" + _toDisplayString(index + 1), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})